import { AuthGuard } from '../../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import {AngularFireDatabase, AngularFireList,  AngularFireObject} from '@angular/fire/database';
import * as firebase from 'firebase';
import {Business} from '../../models/business';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import {CalcRevenue} from '../../models/calc-revenue';



@Injectable({
  providedIn: 'root'
})
export class FireCalcRevenueService {
  calcRevenuesRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  calcRevenueRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public UserBplansInput;
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private calcRevenuePath = 'user-calcRevenue';



   
  sustainibleCalcRevenueRef : AngularFirestoreCollection<CalcRevenue>=null;



  constructor (private db: AngularFireDatabase, private guard: AuthGuard,private dbstore: AngularFirestore ) {
    this.sustainibleCalcRevenueRef = dbstore.collection(this.calcRevenuePath);
   }

   
   // Firestore Assessment Create the Assessment in FireStore
   createSustainibleCalcRevenue ( calcRevenue:CalcRevenue):void {
     this.sustainibleCalcRevenueRef.add({...calcRevenue});
       
   }

   updateSustainibleCalcRevenue ( id:string, value:any): Promise <void> {
    return this.sustainibleCalcRevenueRef.doc(id).update(value);

   }

   deleteSustainibleCalcRevenue (id:string) : Promise <void> {
    return this.sustainibleCalcRevenueRef.doc(id).delete();

   }

   readSustainibleCalcRevenueList ():AngularFirestoreCollection<CalcRevenue> {
    return this.sustainibleCalcRevenueRef;

   }

   // below function doesnt work and can be taken out
public calcRevenueData: any;
public  data1!: any;
  readSustainibleCalcRevenue(id:string) {
    debugger
        //define all variables of a single assessment
      this.calcRevenueData.ref = this.sustainibleCalcRevenueRef.doc(id);
      JSON.stringify(this.calcRevenueData.ref);
      this.calcRevenueData.ref.once("value").then((snapshot) => {
        this.data1 = snapshot.val(); 
        console.log("calcRevenuedata" + this.data1)
      });
    }
      
     
  

   deleteAllSustainibleCalcRevenue () {
     this.sustainibleCalcRevenueRef.get().subscribe(
       querySnapshot => {
         querySnapshot.forEach((doc) =>{
           doc.ref.delete();
         });
       },
       error=>{
         console.log('Error deleting all documents: ', error);
       });
   }

    /**
   * Create assessment in firestore
   * @param calcRevenue - data about CalcRevenue assessment
   * @returns 
   */


  // create assessment
  async createCalcRevenue(calcRevenue: CalcRevenue): Promise<string>  {
    //const key = this.database.ref('/users').push().key; // is this what's causing it? assementref.push..its pushing the key under the uid and on the database
    const adminCode = (await this.dbStore.collection(this.calcRevenuePath).doc(this.guard.uid).get())?.data()?.adminCode;
    const res = await this.sustainibleCalcRevenueRef.add({
        adminCode: adminCode || null,//problem
        userID: this.guard.uid,//problem
        revInitialCapital: calcRevenue.revInitialCapital,
        revStartingCosts: calcRevenue.revStartingCosts,
        revPerUser: calcRevenue.revPerUser,
        revCOGS: calcRevenue.revCOGS,
        revFixedCostPerMonth: calcRevenue.revFixedCostPerMonth,
        revInitUsers: calcRevenue.revInitUsers,
        revMonthlyUserGrowth: calcRevenue.revMonthlyUserGrowth,
        revMonthlyUserLoss: calcRevenue.revMonthlyUserLoss,
        offerListArray: calcRevenue.offerListArray,
      });

      return res.id;
  
    }

 

  ReadCalcRevenue(id: string) {
    this.calcRevenueRef = this.db.object(`users/${this.guard.uid}/` + id);
    return this.calcRevenueRef;
  }

  ReadCalcRevenueList() {
    this.calcRevenuesRef = this.db.list(`users/${this.guard.uid}/`);
    return this.calcRevenuesRef;
  }
  UpdateCalcRevenue(calcRevenue: CalcRevenue) {
    this.calcRevenueRef.update({
      revInitialCapital: calcRevenue.revInitialCapital,
      revStartingCosts: calcRevenue.revStartingCosts,
      revPerUser: calcRevenue.revPerUser,
      revCOGS: calcRevenue.revCOGS,
      revFixedCostPerMonth: calcRevenue.revFixedCostPerMonth,
      revInitUsers: calcRevenue.revInitUsers,
      revMonthlyUserGrowth: calcRevenue.revMonthlyUserGrowth,
      revMonthlyUserLoss: calcRevenue.revMonthlyUserLoss,
      offerListArray: calcRevenue.offerListArray,
    });
  }
  DeleteCalcRevenue() {
    this.calcRevenueRef = this.db.object('users/');
    this.calcRevenueRef.remove();
  }

}